import {createLazyFileRoute} from '@tanstack/react-router'

import FoodGrubhub from '@/views/FoodGrubhub/FoodGrubhub'

export const Route = createLazyFileRoute('/_food-grubhub/food/')({
  component: FoodGrubhub,
})
